import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogService } from './log.service';
import { LogPublisherService } from './log-publisher.service';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedConfig } from './shared-config';
import { ApiRequestService } from './api-request-service';

@NgModule({
    declarations: [],
    exports: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [LogService, LogPublisherService, ApiRequestService]
})
export class SharedModule {
    static forRoot(clientConfig?: SharedConfig): ModuleWithProviders<SharedModule> {
        const finalConfig = new SharedConfig();
        if (clientConfig) {
            if (clientConfig.enableUseCaseStatusLogs) finalConfig.enableUseCaseStatusLogs = clientConfig.enableUseCaseStatusLogs;
            if (clientConfig.logLevel) finalConfig.logLevel = clientConfig.logLevel;
        }
        return {
            ngModule: SharedModule,
            providers: [
                {
                    provide: SharedConfig,
                    useValue: finalConfig
                }
              

            ]
        };
    }
}
